import React from 'react'

import Landing from './subcomponents/landing';
import ProjectCardDeck from './subcomponents/projectCardDeck';
import AboutSummary from './subcomponents/aboutSummary';
import ContactForm from './subcomponents/contactForm';
import ExperienceSummary from './subcomponents/experienceSummary';

const Home = () => {
    return (
        <>
            <Landing />
            <ExperienceSummary />
            <AboutSummary />
            <ProjectCardDeck />
            <ContactForm />
        </>
    )
}

export default Home;